import { Component, OnInit, Input, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import { UserService } from '../shared/user.service';
import { NgForm, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AdmCategoryService } from '../../globalService/adm-category.service';
import { Role } from 'src/app/roles/shared/role';
import { RoleService } from 'src/app/roles/shared/role.service';
import { Company } from 'src/app/business/shared/company';
import { CompanyService } from 'src/app/business/shared/company.service';
import { SelectList } from 'src/app/globalClass/select-list';
import { CiudadesServiceService } from 'src/app/parametricas/ciudades/shared/ciudades-service.service';
import { Select2OptionData } from 'ng-select2';
import { Options } from 'select2'
import { RolesWeCumplimento } from 'src/app/wecumplimiento/shared/helper/rolesWeCumplimientio';
import { ContratistasService } from 'src/app/contratistas/shared/contratistas.service';
import { InfoUserService } from 'src/app/info-user/shared/info-user.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})

export class UserComponent implements OnInit {

  @Input() add!: boolean;
  @Input() edit!: boolean;
  @Output() added = new EventEmitter<boolean>();

  options!: Options;
  singleOptions!: Options;
  userForm!: FormGroup;
  roles!: Role[];
  multiRoles!: Array<Select2OptionData>;
  companys!: Company[];
  multiCompanys!: Array<Select2OptionData>;
  mailMsg!: string;
  mailMsg2!: string;
  listTypeDocument!: SelectList[];
  listCitys!: Array<Select2OptionData>;
  isActiveUser: any;
  isLoader: boolean = false;
  messageLoader: string = 'Cargando ...';
  isUsuarioPacContratista: boolean = false;
  listContratistas!: Array<Select2OptionData>;

  constructor(private userService: UserService,
    private roleService: RoleService,
    private toastr: ToastrService,
    private categoryService: AdmCategoryService,
    private companyService: CompanyService,
    private _fb: FormBuilder,
    private ciudadService: CiudadesServiceService,
    private chRef:ChangeDetectorRef,
    private contratistasService: ContratistasService,
    private _userInfo: InfoUserService,
  ) { }

  ngOnInit() {
    this.isActiveUser = this.userService.isActiveUser;
    this._userInfo.getUserInfo();
    this.initMultipleSelectTest();
    this.loadRoles();
    this.loadSelectListTypeDocument();
    this.loadCities();
    this.loadSelectListContratistas();
    this.loadSubscribe(); 
  }

  loadSubscribe(){
    this.userService.userForm.get('companys')?.valueChanges.subscribe(s => {
      this.validateRolWeCumplimientoCliente(s, this.userService.userForm.get('roles')?.value);
    });
    this.userService.userForm.get('roles')?.valueChanges.subscribe(s => {
      this.validateRolWeCumplimientoCliente(this.userService.userForm.get('companys')?.value, s);
      this.validateRolUsuarioPacContratista(s);
    });
    this.userService.userForm.get('contratista')?.valueChanges.subscribe(s => {
      if(s != null || s != undefined) {
        this.contratistasService.getPacProgramaEmpresaByContratista(Number(s)).then((r: any)=>{
          let companysContratistas = this.companys.filter((f: any) => r?.some((ss: any) => ss.idAdmEmpresa == f.idAdmEmpresa));
          this.loadCompanysSelectMultiple(companysContratistas);
          let companysSelected = companysContratistas?.filter((f)=> this.userService.userForm.get('companys')?.value?.some((ss: any) => ss == f.idAdmEmpresa))
                                                      .map((m: any) => m.idAdmEmpresa.toString());
          this.userService.userForm.get('companys')?.setValue(companysSelected, { emitEvent: false })
        });
      }
    });
  }

  validateRolWeCumplimientoCliente(companys: any[], roles: []){
    if(roles?.some(s => s == RolesWeCumplimento.ClienteWecCumplimiento)){
      const conteoMap = companys?.reduce((contador, item) => {
        contador.set(item, (contador.get(item) || 0) + 1);
        return contador;
      }, new Map());
      if(conteoMap?.size > 1){
        this.toastr.warning("El rol Cliente WeCumplimiento solo puede tener una empresa asociada, por favor valide.");
      }
    }
  }

  validateRolUsuarioPacContratista(roles: []){
    if(roles?.some(s => s == '1013')){//Usuario PACs Contratista
      this.userService.userForm.get('roles')?.setValue(['1013'], {emitEvent: false});
      this.isUsuarioPacContratista = true;
    }
    else{
      this.userService.userForm.get('contratista')?.setValue(null, {emitEvent: false});
      this.isUsuarioPacContratista = false;
      this.loadCompanysSelectMultiple(this.companys);
    }
  }

  isActive(){
    return this.userService.isActiveUser;
  }

  loadCities() {
    this.ciudadService.getCitys2().then(r => this.loadCitiesArray(r));
  }

  initMultipleSelectTest() {
    this.options = {
      width: '300',
      multiple: true,
      tags: true
    };

    this.singleOptions = {
      width: '300',
      multiple: false,
      tags: false
    }
  }

  converToArrayRol(array: any) {
    if(typeof(array)!= 'undefined'){
      return array.map((e: any) => e.idSegRol);
    }else{
      return null;
    }
    
  }

  converToArrayCompany(array: any) {
    if(typeof(array)!= 'undefined'){
    return array.map((e: any) => e.idAdmEmpresa);
    }else{
      return null;
    }
  }

  loadRoles() {
    this.roleService.getRoles().then(r => { this.roles = r as Role[]; this.loadRolesSelectMultiple(r); this.loadCompany() });
  }
  
  loadCompany() {
    this.companyService.getCompany().then(r => { this.companys = r as Company[]; this.loadCompanysSelectMultiple(r);});
  }

  resetForm() {
    this.userService.userForm.reset();
    this.userService.userForm.patchValue({
      IdSegUsuario: 0,
      IdSegTipoPersona: 0,
      NumeroDocumento: '',
      Nombre: '',
      Apellido1: '',
      Apellido2: '',
      Telefono: '',
      CorreoElectronico: '',
      ConfirmarCorreoElectronico: '',
      domainUserName:''
    })
    this.isActiveUser = false;
    this.userService.isActiveUser = this.isActiveUser;
  }

  tipoLogChange(event: any){
    debugger
    let value = event.target.value;
    this.userService.isActiveUser = (value=='true');
    this.userService.userForm.patchValue({
      domainUserName:''
    });
    this.chRef.detectChanges();
  }

  onSubmit() {
    this.isLoader = true;
    if(!this.edit){
      this.insertRecord();
    }else{
      this.updateRecord();
    }
  }

  cancel() {
    this.changeAdd(false);
    this.resetForm();
  }

  changeAdd(action: boolean) {
    this.added.emit(action);
  }

  insertRecord() {
    if(this.validateUsuarioPacContratista()){
      this.userService.saveUser(this.companys, this.roles).then(res => {
        let temp = res as any;
        if (temp.error) {
          this.toastr.error("El usuario ya se encuentra registrado");
          this.isLoader = false;
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          this.toastr.success('Dato Insertado Satisfactoriamente', 'User Register');
          this.changeAdd(false);
          this.userService.refreshList();
          this.resetForm();
          this.isLoader = false;
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      }, e => { this.toastr.success('Algo paso', 'User Register'); console.error(e);this.isLoader = false; });
    }
  }

  updateRecord(){
    if(this.validateUsuarioPacContratista()){
      this.userService.updateUser(this.companys,this.roles).then(res => {
        let temp = res as any;
        if (temp.error) {
          this.toastr.error("El usuario ya se encuentra registrado");
          this.isLoader = false;
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          this.toastr.success('Dato Insertado Satisfactoriamente', 'User Register');
          this.changeAdd(false);
          this.userService.refreshList();
          this.resetForm();
          this.isLoader = false;
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      }, e => { this.toastr.success('Algo paso', 'User Register'); console.error(e);this.isLoader = false; });
    }
  }

  loadSelectListTypeDocument() {
    this.categoryService.getListOfCategory(1).then((r: any) => { this.listTypeDocument = r as SelectList[] });
  }
    
  loadSelectListContratistas() {
    this.contratistasService.getAdmContratista().then((r: any) => { 
      if (r != null) {
        this.listContratistas = [{ id: "-1", text: "" }];
        for (var i = 0; i < r.length; i++) {
          this.listContratistas.push({ id: r[i].idAdmContratista, text: r[i].razonSocial });
        }
      }
    });
  }

  verificaValidTouched(campo: string) {
    return !this.userForm.get(campo)?.valid && this.userForm.get(campo)?.touched;
  }

  verificaEmail(campo: string) {
    let temp: any = this.userForm.get(campo);
    if (temp.errors !== null) {
      if (temp.errors['email']) {
        return temp.errors['email'] && temp.touched;
      }
    }
  }

  equalsTo(otherField: string) {
    const validator = (formControl: FormControl) => {
      if (otherField == null) {
        throw new Error("Diligencie la información del campo");
      }
      if (!formControl.root || !(<FormGroup>formControl.root).controls) {
        return null;
      }
      const field = (<FormGroup>formControl.root).get(otherField);
      if (!field) {
        throw new Error('Diligencie la información del campo');
      }
      if (field.value !== formControl.value) {
        return { equalsTo: otherField }
      }
      return null;
    };
    return validator;
  }

  aplicaCssError(campo: string) {
    return {
      'is-invalid': this.verificaValidTouched(campo),
    }
  }

  aplicaCssConfirm(campo: string, opc: number) {
    (this.userForm.get(campo)?.hasError('equalsTo')) ? this.mailMsg2 = "Los campos no coinciden" : this.mailMsg2 = "Este campo es requerido";
    return {
      'is-invalid': this.userForm.get(campo)?.hasError('equalsTo') || this.verificaValidTouched(campo),
    }
  }

  aplicaCssErrorEmail(campo: string, opc: number) {
    if (opc === 1) {
      (this.verificaEmail(campo)) ? this.mailMsg = "El formato del campo es incorrecto" : this.mailMsg = "Este campo es requerido";
    }
    return {
      'is-invalid': this.verificaValidTouched(campo) || this.verificaEmail(campo),
    }
  }

  loadCitiesArray(objectData: any) {
    if (objectData != null) {
      this.listCitys = [];
      for (var i = 0; i < objectData.length; i++) {
        this.listCitys.push({ id: objectData[i].idAdmCiudad, text: objectData[i].nombre });
      }
    }
  }

  loadCompanysSelectMultiple(objectData: any) {
    if (objectData != null) {
      this.multiCompanys = [];
      for (var i = 0; i < objectData.length; i++) {
        this.multiCompanys.push({ id: objectData[i].idAdmEmpresa, text: objectData[i].nombre });
      }
    }
  }

  loadRolesSelectMultiple(objectData: any) {
    if (objectData != null) {
      this.multiRoles = [];
      for (var i = 0; i < objectData.length; i++) {
        this.multiRoles.push({ id: objectData[i].idSegRol, text: objectData[i].nombre });
      }
    }
  }

  validateUsuarioPacContratista(): boolean{
    let result: boolean = true;
    if(this.isUsuarioPacContratista){
      if(this.userService.userForm.get('contratista')?.value == null || this.userService.userForm.get('contratista')?.value == ""){
        this.toastr.error("El campo contratista es requerido");
          this.isLoader = false;
          result = false;
      }
    }
    return result;
  }
}

